import { useMemo } from 'react';
import {
  FreeLink,
  type FreeLinkConfig,
  pickFreeLinkSettings
} from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';

const LEFT_POSITION_STYLE: FreeLinkConfig['style'] = {
  link: {
    justifyContent: 'left',
    textAlign: 'left',
    paddingLeft: 0
  }
};

const RIGHT_POSITION_STYLE: FreeLinkConfig['style'] = {
  link: {
    justifyContent: 'right',
    textAlign: 'right',
    paddingRight: 0
  }
};

export const StyledFreeLink = () => {
  const { embedType, position, ...settings } = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);

  const floatingStyle = useMemo(() => {
    if (embedType === 'inline') {
      return undefined;
    }

    const { position: positionValue } = position;

    const isLeft = positionValue.includes('left');
    const isRight = positionValue.includes('right');

    if (isLeft) {
      return LEFT_POSITION_STYLE;
    }

    if (isRight) {
      return RIGHT_POSITION_STYLE;
    }

    return undefined;
  }, [embedType, position]);

  const style: FreeLinkConfig['style'] = {
    ...floatingStyle,
    link: {
      ...floatingStyle?.link,
      left: 'auto',
      transform: 'none'
    }
  };

  return (
    <FreeLink
      {...freeLinkSettings}
      appAlias={meta.alias}
      appName={meta.name}
      style={style}
      mode="text"
      textModeProps={{
        customColor: 'rgba(113, 113, 113, 0.8)',
        fontSize: 9,
        forceTwoLines: true
      }}
      iconHidden
    />
  );
};
